import styled from "styled-components/macro";

export const EmailUl = styled.ul`
  display: flex;
  justify-content: space-around;
  margin-top: 0;
  padding: 0;
`;

export const EmailLi = styled.li`
  font-size: 14px;
`;

export const DangerousTd = styled.td`
  white-space: normal;
`;

export const EmailTable = styled.table`
  text-align: center;
  margin: 0 auto;
  padding: 1em;
  width: 100%;
`;

export const EmailAnalysisText = styled.p`
  font-weight: bold;
  font-size: 20px;
  line-height: 26px;
  text-transform: uppercase;
`;

export const EmailExpireText = styled.span`
  font-size:14px;
`;
